import BrickTitle from "@/components/landing/BrickTitle";

const rows = [
  {
    service: "Multi-Item Repair List (3+ tasks)",
    ours: "$85 / hr flat",
    theirs: "$95 – $140 / hr + dispatch",
    advantage: "One visit, one rate — no dispatch fees",
  },
  {
    service: "AC Diagnostic & EPA Service",
    ours: "$170 flat diagnostic",
    theirs: "$180 minimum diagnostic visit fee",
    advantage: "Zero predatory diagnostic markups",
  },
  {
    service: "Custom Welding & Gate Repair",
    ours: "$240 mobile project minimum",
    theirs: "$250+ heavy shop minimum",
    advantage: "Mobile equipment brought right to you",
  },
  {
    service: "3D Print Obsolete Fixture Replacement",
    ours: "$290 max — usually far less",
    theirs: "Entire unit replacement ($300+)",
    advantage: "Rescue existing appliances & fixtures",
  },
];

export default function Comparison() {
  return (
    <section id="comparison" className="py-20 max-w-6xl mx-auto px-4 sm:px-6" data-testid="comparison-section">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">Transparent Value</span>
        <h2 className="text-3xl sm:text-4xl font-bold mt-2">
          <BrickTitle text="Honest Rates vs Typical Contractor Markup" />
        </h2>
        <p className="text-sm text-[#A89F94] mt-3">
          Why pay three dispatch fees to three separate trade companies when one craftsman handles all items with
          superior care and lower overhead?
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse bg-white rounded-xl overflow-hidden border border-[#E6DCD3] shadow-sm" data-testid="comparison-table">
          <thead>
            <tr className="bg-[#1E252B] text-white text-sm">
              <th className="py-4 px-6 font-semibold">Service Type</th>
              <th className="py-4 px-6 font-semibold text-[#FFAE70]">Our Direct Honest Rate</th>
              <th className="py-4 px-6 font-semibold text-[#A39B92]">Typical Franchised Trade Rate</th>
              <th className="py-4 px-6 font-semibold">Your Advantage</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E6DCD3] text-sm text-[#544D45]">
            {rows.map((r) => (
              <tr key={r.service} className="hover:bg-[#FAF6F1]" data-testid={`comparison-row-${r.service.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <td className="py-4 px-6 font-bold text-[#1E252B]">{r.service}</td>
                <td className="py-4 px-6 font-bold text-[#D4691E]">{r.ours}</td>
                <td className="py-4 px-6 text-[#8C847B]">{r.theirs}</td>
                <td className="py-4 px-6 text-xs font-semibold text-emerald-700 bg-emerald-50/50">{r.advantage}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-[#8F9BA6] mt-4 text-center">
        * My real rates, held about $10 under typical local trade pricing. Every job still receives an upfront
        written quote before work begins.
      </p>
    </section>
  );
}
